module.exports = __webpack_public_path__ + "img/approval-5.1c0dd3d0.png";